module.exports = __webpack_public_path__ + "img/img21.87e38f97.png";